// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_MapInt = require("rescript/lib/js/belt_MapInt.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_module = require("rescript/lib/js/caml_module.js");
var CustomMap$SmartcutsMacros = require("../CustomMap.bs.js");
var ArrayUtils$SmartcutsMacros = require("../../../bs-utils/src/ArrayUtils.bs.js");
var OptionUtils$SmartcutsMacros = require("../../../bs-utils/src/OptionUtils.bs.js");
var STEM__Client$SmartcutsMacros = require("../../../bs-data-extraction/src/STEM__Client.bs.js");
var PromisedValue$SmartcutsMacros = require("../PromisedValue.bs.js");
var PaginateOptions$SmartcutsMacros = require("./shared/PaginateOptions.bs.js");
var STEM__Interfaces$SmartcutsMacros = require("../../../bs-data-extraction/src/STEM__Interfaces.bs.js");
var DataExtraction__DataRecord$SmartcutsMacros = require("../../../bs-data-extraction/src/DataExtraction__DataRecord.bs.js");
var DataExtraction__ExportToTable$SmartcutsMacros = require("../../../bs-data-extraction/src/DataExtraction__ExportToTable.bs.js");
var DataExtraction__DataRecord__Types$SmartcutsMacros = require("../../../bs-data-extraction/src/DataExtraction__DataRecord__Types.bs.js");

function dataNodeId_encode(v) {
  return DataExtraction__DataRecord__Types$SmartcutsMacros.DataNodeId.t_encode(v);
}

function dataNodeId_decode(v) {
  return DataExtraction__DataRecord__Types$SmartcutsMacros.DataNodeId.t_decode(v);
}

function htmlTagPathIdentifier_encode(v) {
  return STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.t_encode(v);
}

function htmlTagPathIdentifier_decode(v) {
  return STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.t_decode(v);
}

function googleSheet_encode(v) {
  return Js_dict.fromArray([
              [
                "spreadsheetId",
                Decco.stringToJson(v.spreadsheetId)
              ],
              [
                "spreadsheetName",
                Decco.stringToJson(v.spreadsheetName)
              ],
              [
                "spreadsheetUrl",
                Decco.stringToJson(v.spreadsheetUrl)
              ],
              [
                "worksheetName",
                Decco.stringToJson(v.worksheetName)
              ]
            ]);
}

function googleSheet_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var spreadsheetId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "spreadsheetId"), null));
  if (spreadsheetId.TAG === /* Ok */0) {
    var spreadsheetName = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "spreadsheetName"), null));
    if (spreadsheetName.TAG === /* Ok */0) {
      var spreadsheetUrl = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "spreadsheetUrl"), null));
      if (spreadsheetUrl.TAG === /* Ok */0) {
        var worksheetName = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "worksheetName"), null));
        if (worksheetName.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    spreadsheetId: spreadsheetId._0,
                    spreadsheetName: spreadsheetName._0,
                    spreadsheetUrl: spreadsheetUrl._0,
                    worksheetName: worksheetName._0
                  }
                };
        }
        var e = worksheetName._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".worksheetName" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = spreadsheetUrl._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".spreadsheetUrl" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = spreadsheetName._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".spreadsheetName" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = spreadsheetId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".spreadsheetId" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function snapshotOfDataExported_encode(v) {
  return Js_dict.fromArray([
              [
                "columns",
                Decco.arrayToJson((function (param) {
                        return DataExtraction__ExportToTable$SmartcutsMacros.column_encode(Decco.unitToJson, param);
                      }), v.columns)
              ],
              [
                "rows",
                Decco.arrayToJson((function (param) {
                        return Decco.arrayToJson((function (param) {
                                      return DataExtraction__ExportToTable$SmartcutsMacros.cell_encode(DataExtraction__ExportToTable$SmartcutsMacros.columnRef_encode, param);
                                    }), param);
                      }), v.rows)
              ]
            ]);
}

function snapshotOfDataExported_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var columns = Decco.arrayFromJson((function (param) {
          return DataExtraction__ExportToTable$SmartcutsMacros.column_decode(Decco.unitFromJson, param);
        }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "columns"), null));
  if (columns.TAG === /* Ok */0) {
    var rows = Decco.arrayFromJson((function (param) {
            return Decco.arrayFromJson((function (param) {
                          return DataExtraction__ExportToTable$SmartcutsMacros.cell_decode(DataExtraction__ExportToTable$SmartcutsMacros.columnRef_decode, param);
                        }), param);
          }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "rows"), null));
    if (rows.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                columns: columns._0,
                rows: rows._0
              }
            };
    }
    var e = rows._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".rows" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = columns._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".columns" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

var HtpiByTagPathString = Caml_module.init_mod([
      "WithElementGroupsCommand.re",
      32,
      4
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "lookupByTagPath"
        ],
        [
          /* Function */0,
          "fromDataRecordPatterns"
        ]
      ]
    });

var DataRecordPattern = Caml_module.init_mod([
      "WithElementGroupsCommand.re",
      84,
      4
    ], {
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "t_encode"
              ],
              [
                /* Function */0,
                "t_decode"
              ],
              [
                /* Function */0,
                "subPattern_encode"
              ],
              [
                /* Function */0,
                "subPattern_decode"
              ]
            ]
          },
          "TagPaths"
        ],
        [
          /* Function */0,
          "t_encode"
        ],
        [
          /* Function */0,
          "t_decode"
        ],
        [
          /* Function */0,
          "doesMatchDataRegionGroup"
        ]
      ]
    });

function lookupByTagPath(htpiByTagPathString, tagPath) {
  return List.assoc_opt(STEM__Client$SmartcutsMacros.HtmlTagPath.toTagPathString(tagPath), htpiByTagPathString);
}

function fromDataRecordPatterns(dataRecordPatterns) {
  return $$Array.to_list(ArrayUtils$SmartcutsMacros.flatMap((function (dataRecordPattern) {
                    var match = dataRecordPattern._0;
                    var rootPath = match.rootPath;
                    return Belt_Array.map(match.subPatterns, (function (param) {
                                  return [
                                          Belt_Array.concat(rootPath, param.path).join(">"),
                                          param.id
                                        ];
                                }));
                  }), dataRecordPatterns));
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "lookupByTagPath"
        ],
        [
          /* Function */0,
          "fromDataRecordPatterns"
        ]
      ]
    }, HtpiByTagPathString, {
      lookupByTagPath: lookupByTagPath,
      fromDataRecordPatterns: fromDataRecordPatterns
    });

function subPattern_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var path = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "path"), null));
    if (path.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                id: id._0,
                path: path._0
              }
            };
    }
    var e = path._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".path" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function subPattern_encode(v) {
  return Js_dict.fromArray([
              [
                "id",
                STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.t_encode(v.id)
              ],
              [
                "path",
                Decco.arrayToJson(Decco.stringToJson, v.path)
              ]
            ]);
}

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "rootPath",
                Decco.arrayToJson(Decco.stringToJson, v.rootPath)
              ],
              [
                "subPatterns",
                Decco.arrayToJson(subPattern_encode, v.subPatterns)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var rootPath = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "rootPath"), null));
  if (rootPath.TAG === /* Ok */0) {
    var subPatterns = Decco.arrayFromJson(subPattern_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "subPatterns"), null));
    if (subPatterns.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                rootPath: rootPath._0,
                subPatterns: subPatterns._0
              }
            };
    }
    var e = subPatterns._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".subPatterns" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = rootPath._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".rootPath" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

var TagPaths = {
  t_encode: t_encode,
  t_decode: t_decode,
  subPattern_encode: subPattern_encode,
  subPattern_decode: subPattern_decode
};

function t_encode$1(v) {
  return [
          "TagPaths",
          t_encode(v._0)
        ];
}

function t_decode$1(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "TagPaths") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* TagPaths */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function doesMatchDataRegionGroup(firstDataRecordPatternOfRecording, dataRegionGroup, client, htmlTagPathIdentifierByTagPathString) {
  var subPatterns = firstDataRecordPatternOfRecording._0.subPatterns;
  return Belt_Option.getWithDefault(Belt_Option.map(Belt_Array.get(dataRegionGroup, 0), (function (firstDataRegion) {
                    return Belt_Option.getWithDefault(Belt_Option.map(Belt_Array.get(Curry._2(STEM__Client$SmartcutsMacros.DataRegion.getNodes, client, firstDataRegion), 0), (function (param) {
                                      return Belt_Option.getWithDefault(Belt_Option.map(Curry._2(HtpiByTagPathString.lookupByTagPath, htmlTagPathIdentifierByTagPathString, param.tagPath), (function (htpi) {
                                                        return Caml_obj.caml_equal(htpi, Caml_array.get(subPatterns, 0).id);
                                                      })), false);
                                    })), false);
                  })), false);
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "t_encode"
              ],
              [
                /* Function */0,
                "t_decode"
              ],
              [
                /* Function */0,
                "subPattern_encode"
              ],
              [
                /* Function */0,
                "subPattern_decode"
              ]
            ]
          },
          "TagPaths"
        ],
        [
          /* Function */0,
          "t_encode"
        ],
        [
          /* Function */0,
          "t_decode"
        ],
        [
          /* Function */0,
          "doesMatchDataRegionGroup"
        ]
      ]
    }, DataRecordPattern, {
      TagPaths: TagPaths,
      t_encode: t_encode$1,
      t_decode: t_decode$1,
      doesMatchDataRegionGroup: doesMatchDataRegionGroup
    });

function condition_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "Todo") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* Todo */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function condition_encode(v) {
  return ["Todo"];
}

function keepOnly_encode(v) {
  return Js_dict.fromArray([
              [
                "dataNodeId",
                DataExtraction__DataRecord__Types$SmartcutsMacros.DataNodeId.t_encode(v.dataNodeId)
              ],
              [
                "condition",
                ["Todo"]
              ]
            ]);
}

function keepOnly_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var dataNodeId = DataExtraction__DataRecord__Types$SmartcutsMacros.DataNodeId.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "dataNodeId"), null));
  if (dataNodeId.TAG === /* Ok */0) {
    var condition = condition_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "condition"), null));
    if (condition.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                dataNodeId: dataNodeId._0,
                condition: condition._0
              }
            };
    }
    var e = condition._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".condition" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = dataNodeId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".dataNodeId" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function t_encode$2(v) {
  return [
          "KeepOnly",
          keepOnly_encode(v._0)
        ];
}

function t_decode$2(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "KeepOnly") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = keepOnly_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* KeepOnly */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringifyCondition(condition) {
  return "Todo";
}

function stringify(transducer) {
  return "KeeyOnly({dataNodeId: " + (DataExtraction__DataRecord__Types$SmartcutsMacros.DataNodeId.stringify(transducer._0.dataNodeId) + ", condition: Todo})");
}

var Transducer = {
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  keepOnly_encode: keepOnly_encode,
  keepOnly_decode: keepOnly_decode,
  condition_encode: condition_encode,
  condition_decode: condition_decode,
  stringifyCondition: stringifyCondition,
  stringify: stringify
};

function destination_encode(v) {
  return [
          "GoogleSheet",
          googleSheet_encode(v._0)
        ];
}

function exportTo_encode(v) {
  return Js_dict.fromArray([
              [
                "destination",
                destination_encode(v.destination)
              ],
              [
                "columns",
                Decco.arrayToJson((function (param) {
                        return DataExtraction__ExportToTable$SmartcutsMacros.column_encode(Decco.unitToJson, param);
                      }), v.columns)
              ],
              [
                "maybeExtraColumns",
                Decco.optionToJson((function (param) {
                        return Decco.arrayToJson(DataExtraction__ExportToTable$SmartcutsMacros.ExtraColumn.t_encode, param);
                      }), v.maybeExtraColumns)
              ],
              [
                "maybePrimayKeys",
                Decco.optionToJson((function (param) {
                        return Decco.arrayToJson(DataExtraction__ExportToTable$SmartcutsMacros.columnRef_encode, param);
                      }), v.maybePrimayKeys)
              ],
              [
                "snapshotOfDataExported",
                snapshotOfDataExported_encode(v.snapshotOfDataExported)
              ]
            ]);
}

function dataNode_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var tagPath = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "tagPath"), null));
  if (tagPath.TAG === /* Ok */0) {
    var htmlTagPathIdentifier = STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "htmlTagPathIdentifier"), null));
    if (htmlTagPathIdentifier.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                tagPath: tagPath._0,
                htmlTagPathIdentifier: htmlTagPathIdentifier._0
              }
            };
    }
    var e = htmlTagPathIdentifier._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".htmlTagPathIdentifier" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = tagPath._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".tagPath" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function dataRegionResolved_encode(v) {
  return Decco.arrayToJson(dataNode_encode, v);
}

function dataRegionResolved_decode(v) {
  return Decco.arrayFromJson(dataNode_decode, v);
}

function sequenceOfElementsOnPage_encode(v) {
  return Js_dict.fromArray([
              [
                "dataRegionsResolved",
                Decco.arrayToJson(dataRegionResolved_encode, v.dataRegionsResolved)
              ],
              [
                "dataSchema",
                Curry._1(DataExtraction__DataRecord$SmartcutsMacros.Schema.WithHTPIAndTagPathAndDataNodeId.t_encode, v.dataSchema)
              ]
            ]);
}

function dataNode_encode(v) {
  return Js_dict.fromArray([
              [
                "tagPath",
                Decco.arrayToJson(Decco.stringToJson, v.tagPath)
              ],
              [
                "htmlTagPathIdentifier",
                STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.t_encode(v.htmlTagPathIdentifier)
              ]
            ]);
}

function exportTo_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var destination = destination_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "destination"), null));
  if (destination.TAG === /* Ok */0) {
    var columns = Decco.arrayFromJson((function (param) {
            return DataExtraction__ExportToTable$SmartcutsMacros.column_decode(Decco.unitFromJson, param);
          }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "columns"), null));
    if (columns.TAG === /* Ok */0) {
      var maybeExtraColumns = Decco.optionFromJson((function (param) {
              return Decco.arrayFromJson(DataExtraction__ExportToTable$SmartcutsMacros.ExtraColumn.t_decode, param);
            }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeExtraColumns"), null));
      if (maybeExtraColumns.TAG === /* Ok */0) {
        var maybePrimayKeys = Decco.optionFromJson((function (param) {
                return Decco.arrayFromJson(DataExtraction__ExportToTable$SmartcutsMacros.columnRef_decode, param);
              }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybePrimayKeys"), null));
        if (maybePrimayKeys.TAG === /* Ok */0) {
          var snapshotOfDataExported = snapshotOfDataExported_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "snapshotOfDataExported"), null));
          if (snapshotOfDataExported.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      destination: destination._0,
                      columns: columns._0,
                      maybeExtraColumns: maybeExtraColumns._0,
                      maybePrimayKeys: maybePrimayKeys._0,
                      snapshotOfDataExported: snapshotOfDataExported._0
                    }
                  };
          }
          var e = snapshotOfDataExported._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".snapshotOfDataExported" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = maybePrimayKeys._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".maybePrimayKeys" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = maybeExtraColumns._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".maybeExtraColumns" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = columns._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".columns" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = destination._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".destination" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

function destination_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "GoogleSheet") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = googleSheet_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* GoogleSheet */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function sequenceOfElementsOnPage_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var dataRegionsResolved = Decco.arrayFromJson(dataRegionResolved_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "dataRegionsResolved"), null));
  if (dataRegionsResolved.TAG === /* Ok */0) {
    var dataSchema = Curry._1(DataExtraction__DataRecord$SmartcutsMacros.Schema.WithHTPIAndTagPathAndDataNodeId.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "dataSchema"), null));
    if (dataSchema.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                dataRegionsResolved: dataRegionsResolved._0,
                dataSchema: dataSchema._0
              }
            };
    }
    var e = dataSchema._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".dataSchema" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = dataRegionsResolved._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".dataRegionsResolved" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function action_encode(v) {
  return [
          "ExportTo",
          exportTo_encode(v._0)
        ];
}

function sequence_encode(v) {
  return [
          "SequenceOfElementsOnPage",
          sequenceOfElementsOnPage_encode(v._0)
        ];
}

function action_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "ExportTo") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = exportTo_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* ExportTo */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function sequence_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "SequenceOfElementsOnPage") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = sequenceOfElementsOnPage_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* SequenceOfElementsOnPage */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function t_encode$3(v) {
  return Js_dict.fromArray([
              [
                "sequence",
                sequence_encode(v.sequence)
              ],
              [
                "actions",
                Decco.arrayToJson(action_encode, v.actions)
              ],
              [
                "paginateOptions",
                PaginateOptions$SmartcutsMacros.t_encode(v.paginateOptions)
              ]
            ]);
}

function t_decode$3(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var sequence = sequence_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sequence"), null));
  if (sequence.TAG === /* Ok */0) {
    var actions = Decco.arrayFromJson(action_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "actions"), null));
    if (actions.TAG === /* Ok */0) {
      var paginateOptions = PaginateOptions$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "paginateOptions"), null));
      if (paginateOptions.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  sequence: sequence._0,
                  actions: actions._0,
                  paginateOptions: paginateOptions._0
                }
              };
      }
      var e = paginateOptions._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".paginateOptions" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = actions._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".actions" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = sequence._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".sequence" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function stringify$1(param) {
  return "{ seqeuence: SequenceOfElementsOnPage({dataRegionsResolved, dataSchema}), actions: [" + (Belt_Array.map(param.actions, (function (action) {
                    var match = action._0;
                    return "ExportTo({destination: GoogleSheet(_), columns: [n=" + (String(match.columns.length) + ("], exportExtraColumns: [" + (OptionUtils$SmartcutsMacros.stringify((function (exportExtraColumns) {
                                        return Belt_Array.map(exportExtraColumns, DataExtraction__ExportToTable$SmartcutsMacros.ExtraColumn.stringify).join(",");
                                      }), match.maybeExtraColumns) + "]})")));
                  })).join(", ") + "] }");
}

function getIdentifier(param) {
  return "collect SequenceOfElementsOnPage";
}

var RecordingAndAuthoring = {
  t_encode: t_encode$3,
  t_decode: t_decode$3,
  destination_encode: destination_encode,
  destination_decode: destination_decode,
  sequence_encode: sequence_encode,
  sequence_decode: sequence_decode,
  sequenceOfElementsOnPage_encode: sequenceOfElementsOnPage_encode,
  sequenceOfElementsOnPage_decode: sequenceOfElementsOnPage_decode,
  dataRegionResolved_encode: dataRegionResolved_encode,
  dataRegionResolved_decode: dataRegionResolved_decode,
  dataNode_encode: dataNode_encode,
  dataNode_decode: dataNode_decode,
  action_encode: action_encode,
  action_decode: action_decode,
  exportTo_encode: exportTo_encode,
  exportTo_decode: exportTo_decode,
  stringify: stringify$1,
  getIdentifier: getIdentifier
};

function destination_encode$1(v) {
  if (v.TAG === /* ExistingGoogleSheet */0) {
    return [
            "ExistingGoogleSheet",
            googleSheet_encode(v._0)
          ];
  } else {
    return [
            "NewGoogleSheet",
            PromisedValue$SmartcutsMacros.t_encode(googleSheet_encode, Decco.stringToJson, v._0)
          ];
  }
}

function exportTo_encode$1(v) {
  return Js_dict.fromArray([
              [
                "destination",
                destination_encode$1(v.destination)
              ],
              [
                "columns",
                Decco.arrayToJson((function (param) {
                        return DataExtraction__ExportToTable$SmartcutsMacros.column_encode(Decco.unitToJson, param);
                      }), v.columns)
              ],
              [
                "maybeExtraColumns",
                Decco.optionToJson((function (param) {
                        return Decco.arrayToJson(DataExtraction__ExportToTable$SmartcutsMacros.ExtraColumn.t_encode, param);
                      }), v.maybeExtraColumns)
              ],
              [
                "maybePrimayKeys",
                Decco.optionToJson((function (param) {
                        return Decco.arrayToJson(DataExtraction__ExportToTable$SmartcutsMacros.columnRef_encode, param);
                      }), v.maybePrimayKeys)
              ],
              [
                "snapshotOfDataExported",
                snapshotOfDataExported_encode(v.snapshotOfDataExported)
              ]
            ]);
}

function sequenceOfElementsOnPage_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var alias = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "alias"), null));
  if (alias.TAG === /* Ok */0) {
    var dataRecordPatterns = Decco.arrayFromJson(DataRecordPattern.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "dataRecordPatterns"), null));
    if (dataRecordPatterns.TAG === /* Ok */0) {
      var dataRecordSchema = Curry._1(DataExtraction__DataRecord$SmartcutsMacros.Schema.WithHTPIAndTagPathAndDataNodeId.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "dataRecordSchema"), null));
      if (dataRecordSchema.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  alias: alias._0,
                  dataRecordPatterns: dataRecordPatterns._0,
                  dataRecordSchema: dataRecordSchema._0
                }
              };
      }
      var e = dataRecordSchema._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".dataRecordSchema" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = dataRecordPatterns._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".dataRecordPatterns" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = alias._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".alias" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function sequenceOfElementsOnPage_encode$1(v) {
  return Js_dict.fromArray([
              [
                "alias",
                Decco.optionToJson(Decco.stringToJson, v.alias)
              ],
              [
                "dataRecordPatterns",
                Decco.arrayToJson(DataRecordPattern.t_encode, v.dataRecordPatterns)
              ],
              [
                "dataRecordSchema",
                Curry._1(DataExtraction__DataRecord$SmartcutsMacros.Schema.WithHTPIAndTagPathAndDataNodeId.t_encode, v.dataRecordSchema)
              ]
            ]);
}

function destination_decode$1(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "ExistingGoogleSheet" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = googleSheet_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ExistingGoogleSheet */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "NewGoogleSheet" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = PromisedValue$SmartcutsMacros.t_decode(googleSheet_decode, Decco.stringFromJson, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* NewGoogleSheet */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function exportTo_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var destination = destination_decode$1(Belt_Option.getWithDefault(Js_dict.get(dict$1, "destination"), null));
  if (destination.TAG === /* Ok */0) {
    var columns = Decco.arrayFromJson((function (param) {
            return DataExtraction__ExportToTable$SmartcutsMacros.column_decode(Decco.unitFromJson, param);
          }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "columns"), null));
    if (columns.TAG === /* Ok */0) {
      var maybeExtraColumns = Decco.optionFromJson((function (param) {
              return Decco.arrayFromJson(DataExtraction__ExportToTable$SmartcutsMacros.ExtraColumn.t_decode, param);
            }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeExtraColumns"), null));
      if (maybeExtraColumns.TAG === /* Ok */0) {
        var maybePrimayKeys = Decco.optionFromJson((function (param) {
                return Decco.arrayFromJson(DataExtraction__ExportToTable$SmartcutsMacros.columnRef_decode, param);
              }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybePrimayKeys"), null));
        if (maybePrimayKeys.TAG === /* Ok */0) {
          var snapshotOfDataExported = snapshotOfDataExported_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "snapshotOfDataExported"), null));
          if (snapshotOfDataExported.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      destination: destination._0,
                      columns: columns._0,
                      maybeExtraColumns: maybeExtraColumns._0,
                      maybePrimayKeys: maybePrimayKeys._0,
                      snapshotOfDataExported: snapshotOfDataExported._0
                    }
                  };
          }
          var e = snapshotOfDataExported._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".snapshotOfDataExported" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = maybePrimayKeys._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".maybePrimayKeys" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = maybeExtraColumns._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".maybeExtraColumns" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = columns._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".columns" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = destination._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".destination" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

function iteratorStrategy_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "PaginateAllFirstThenAct") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* PaginateAllFirstThenAct */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function action_decode$1(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "ExportTo") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = exportTo_decode$1(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* ExportTo */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function sequence_decode$1(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "SequenceOfElementsOnPage") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = sequenceOfElementsOnPage_decode$1(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* SequenceOfElementsOnPage */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function iteratorStrategy_encode(v) {
  return ["PaginateAllFirstThenAct"];
}

function sequence_encode$1(v) {
  return [
          "SequenceOfElementsOnPage",
          sequenceOfElementsOnPage_encode$1(v._0)
        ];
}

function action_encode$1(v) {
  return [
          "ExportTo",
          exportTo_encode$1(v._0)
        ];
}

function t_encode$4(v) {
  return Js_dict.fromArray([
              [
                "sequence",
                sequence_encode$1(v.sequence)
              ],
              [
                "iteratorStrategy",
                ["PaginateAllFirstThenAct"]
              ],
              [
                "paginateOptions",
                PaginateOptions$SmartcutsMacros.t_encode(v.paginateOptions)
              ],
              [
                "transducers",
                Decco.arrayToJson(t_encode$2, v.transducers)
              ],
              [
                "actions",
                Decco.arrayToJson(action_encode$1, v.actions)
              ]
            ]);
}

function t_decode$4(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var sequence = sequence_decode$1(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sequence"), null));
  if (sequence.TAG === /* Ok */0) {
    var iteratorStrategy = iteratorStrategy_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "iteratorStrategy"), null));
    if (iteratorStrategy.TAG === /* Ok */0) {
      var paginateOptions = PaginateOptions$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "paginateOptions"), null));
      if (paginateOptions.TAG === /* Ok */0) {
        var transducers = Decco.arrayFromJson(t_decode$2, Belt_Option.getWithDefault(Js_dict.get(dict$1, "transducers"), null));
        if (transducers.TAG === /* Ok */0) {
          var actions = Decco.arrayFromJson(action_decode$1, Belt_Option.getWithDefault(Js_dict.get(dict$1, "actions"), null));
          if (actions.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      sequence: sequence._0,
                      iteratorStrategy: iteratorStrategy._0,
                      paginateOptions: paginateOptions._0,
                      transducers: transducers._0,
                      actions: actions._0
                    }
                  };
          }
          var e = actions._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".actions" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = transducers._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".transducers" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = paginateOptions._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".paginateOptions" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = iteratorStrategy._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".iteratorStrategy" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = sequence._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".sequence" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

function stringifyDestination(destination) {
  if (destination.TAG === /* ExistingGoogleSheet */0) {
    return "ExistingGoogleSheet(_)";
  } else {
    return "NewGoogleSheet(_)";
  }
}

function stringifyAction(action) {
  var match = action._0;
  return "ExportTo({destination: " + (stringifyDestination(match.destination) + (", columns: [n=" + (String(match.columns.length) + "]})")));
}

function stringify$2(param) {
  return "{ sequence: SequenceOfElementsOnPage({alias, dataRecordPatterns, dataRecordSchema}), iteratorStrategy: PaginateAllFirstThenAct, paginate: " + (PaginateOptions$SmartcutsMacros.stringify(param.paginateOptions) + (", transducers: [" + (Belt_Array.map(param.transducers, stringify).join(", ") + ("], actions: " + (Belt_Array.map(param.actions, stringifyAction).join(", ") + "]}")))));
}

function fromRecordingAuthoring(param) {
  var match = param.sequence._0;
  var dataSchema = match.dataSchema;
  return {
          sequence: /* SequenceOfElementsOnPage */{
            _0: {
              alias: dataSchema.friendlyName,
              dataRecordPatterns: Belt_Array.map(match.dataRegionsResolved, (function (dataRegionResolved) {
                      return /* TagPaths */{
                              _0: {
                                rootPath: [],
                                subPatterns: Belt_Array.map(dataRegionResolved, (function (param) {
                                        return {
                                                id: param.htmlTagPathIdentifier,
                                                path: param.tagPath
                                              };
                                      }))
                              }
                            };
                    })),
              dataRecordSchema: dataSchema
            }
          },
          iteratorStrategy: /* PaginateAllFirstThenAct */0,
          paginateOptions: param.paginateOptions,
          transducers: [],
          actions: Belt_Array.map(param.actions, (function (action) {
                  var match = action._0;
                  return /* ExportTo */{
                          _0: {
                            destination: {
                              TAG: /* ExistingGoogleSheet */0,
                              _0: match.destination._0
                            },
                            columns: match.columns,
                            maybeExtraColumns: match.maybeExtraColumns,
                            maybePrimayKeys: match.maybePrimayKeys,
                            snapshotOfDataExported: match.snapshotOfDataExported
                          }
                        };
                }))
        };
}

var Playback = {
  t_encode: t_encode$4,
  t_decode: t_decode$4,
  sequence_encode: sequence_encode$1,
  sequence_decode: sequence_decode$1,
  sequenceOfElementsOnPage_encode: sequenceOfElementsOnPage_encode$1,
  sequenceOfElementsOnPage_decode: sequenceOfElementsOnPage_decode$1,
  iteratorStrategy_encode: iteratorStrategy_encode,
  iteratorStrategy_decode: iteratorStrategy_decode,
  action_encode: action_encode$1,
  action_decode: action_decode$1,
  destination_encode: destination_encode$1,
  destination_decode: destination_decode$1,
  exportTo_encode: exportTo_encode$1,
  exportTo_decode: exportTo_decode$1,
  stringifyDestination: stringifyDestination,
  stringifyAction: stringifyAction,
  stringify: stringify$2,
  fromRecordingAuthoring: fromRecordingAuthoring
};

var CommandValue = {
  RecordingAndAuthoring: RecordingAndAuthoring,
  Playback: Playback
};

function action_decode$2(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "ExportTo") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = destination_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* ExportTo */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function action_encode$2(v) {
  return [
          "ExportTo",
          destination_encode(v._0)
        ];
}

function t_encode$5(v) {
  return Js_dict.fromArray([
              [
                "playbackFormLabel",
                Decco.stringToJson(v.playbackFormLabel)
              ],
              [
                "actions",
                Decco.arrayToJson(action_encode$2, v.actions)
              ],
              [
                "paginateOptions",
                PaginateOptions$SmartcutsMacros.t_encode(v.paginateOptions)
              ]
            ]);
}

function t_decode$5(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var playbackFormLabel = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackFormLabel"), null));
  if (playbackFormLabel.TAG === /* Ok */0) {
    var actions = Decco.arrayFromJson(action_decode$2, Belt_Option.getWithDefault(Js_dict.get(dict$1, "actions"), null));
    if (actions.TAG === /* Ok */0) {
      var paginateOptions = PaginateOptions$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "paginateOptions"), null));
      if (paginateOptions.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  playbackFormLabel: playbackFormLabel._0,
                  actions: actions._0,
                  paginateOptions: paginateOptions._0
                }
              };
      }
      var e = paginateOptions._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".paginateOptions" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = actions._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".actions" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = playbackFormLabel._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".playbackFormLabel" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function fromCommandValue(param) {
  return {
          playbackFormLabel: "Collect data from elements on page",
          actions: Belt_Array.map(param.actions, (function (action) {
                  return /* ExportTo */{
                          _0: action._0.destination
                        };
                })),
          paginateOptions: param.paginateOptions
        };
}

function updateConfigWithPlaybackFormLabel(playbackFormLabel, authoringConfig) {
  return {
          playbackFormLabel: playbackFormLabel,
          actions: authoringConfig.actions,
          paginateOptions: authoringConfig.paginateOptions
        };
}

function isDynamic(_authoringConfig) {
  return true;
}

var AuthoringConfig = {
  t_encode: t_encode$5,
  t_decode: t_decode$5,
  action_encode: action_encode$2,
  action_decode: action_decode$2,
  fromCommandValue: fromCommandValue,
  updateConfigWithPlaybackFormLabel: updateConfigWithPlaybackFormLabel,
  isDynamic: isDynamic
};

function action_decode$3(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "ExportTo") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = destination_decode$1(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* ExportTo */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function action_encode$3(v) {
  return [
          "ExportTo",
          destination_encode$1(v._0)
        ];
}

function t_encode$6(v) {
  return Js_dict.fromArray([
              [
                "playbackFormLabel",
                Decco.stringToJson(v.playbackFormLabel)
              ],
              [
                "actions",
                Decco.arrayToJson(action_encode$3, v.actions)
              ],
              [
                "paginateOptions",
                PaginateOptions$SmartcutsMacros.t_encode(v.paginateOptions)
              ]
            ]);
}

function t_decode$6(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var playbackFormLabel = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackFormLabel"), null));
  if (playbackFormLabel.TAG === /* Ok */0) {
    var actions = Decco.arrayFromJson(action_decode$3, Belt_Option.getWithDefault(Js_dict.get(dict$1, "actions"), null));
    if (actions.TAG === /* Ok */0) {
      var paginateOptions = PaginateOptions$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "paginateOptions"), null));
      if (paginateOptions.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  playbackFormLabel: playbackFormLabel._0,
                  actions: actions._0,
                  paginateOptions: paginateOptions._0
                }
              };
      }
      var e = paginateOptions._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".paginateOptions" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = actions._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".actions" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = playbackFormLabel._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".playbackFormLabel" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function fromAuthoringConfig(param) {
  return {
          playbackFormLabel: param.playbackFormLabel,
          actions: Belt_Array.map(param.actions, (function (action) {
                  return /* ExportTo */{
                          _0: {
                            TAG: /* ExistingGoogleSheet */0,
                            _0: action._0._0
                          }
                        };
                })),
          paginateOptions: param.paginateOptions
        };
}

function getPlaybackFormLabelFromParam(param) {
  return param.playbackFormLabel;
}

function removePrivateInfo(withElementGroupsParam) {
  return {
          playbackFormLabel: withElementGroupsParam.playbackFormLabel,
          actions: Belt_Array.map(withElementGroupsParam.actions, (function (action) {
                  return /* ExportTo */{
                          _0: {
                            TAG: /* NewGoogleSheet */1,
                            _0: {
                              TAG: /* Pending */1,
                              _0: "Insert sheet name here"
                            }
                          }
                        };
                })),
          paginateOptions: withElementGroupsParam.paginateOptions
        };
}

var ParamDescriptor = {
  t_encode: t_encode$6,
  t_decode: t_decode$6,
  action_encode: action_encode$3,
  action_decode: action_decode$3,
  fromAuthoringConfig: fromAuthoringConfig,
  getPlaybackFormLabelFromParam: getPlaybackFormLabelFromParam,
  removePrivateInfo: removePrivateInfo
};

function action_decode$4(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "ExportTo") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = destination_decode$1(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* ExportTo */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function action_encode$4(v) {
  return [
          "ExportTo",
          destination_encode$1(v._0)
        ];
}

var destination_decode$2 = destination_decode$1;

var destination_encode$2 = destination_encode$1;

function t_encode$7(v) {
  return Js_dict.fromArray([
              [
                "actions",
                Decco.arrayToJson(action_encode$4, v.actions)
              ],
              [
                "paginateOptions",
                PaginateOptions$SmartcutsMacros.t_encode(v.paginateOptions)
              ]
            ]);
}

function t_decode$7(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var actions = Decco.arrayFromJson(action_decode$4, Belt_Option.getWithDefault(Js_dict.get(dict$1, "actions"), null));
  if (actions.TAG === /* Ok */0) {
    var paginateOptions = PaginateOptions$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "paginateOptions"), null));
    if (paginateOptions.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                actions: actions._0,
                paginateOptions: paginateOptions._0
              }
            };
    }
    var e = paginateOptions._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".paginateOptions" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = actions._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".actions" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function stringify$3(param) {
  return "{ action: [" + (Belt_Array.map(param.actions, (function (action) {
                    return "ExportTo(" + (stringifyDestination(action._0) + ")");
                  })).join(", ") + "] }");
}

function fromParamDescriptor(param) {
  return {
          actions: Belt_Array.map(param.actions, (function (action) {
                  return /* ExportTo */{
                          _0: action._0
                        };
                })),
          paginateOptions: param.paginateOptions
        };
}

function toPlaybackCommandValue(oldCommandValue, param) {
  var actions = param.actions;
  return {
          sequence: oldCommandValue.sequence,
          iteratorStrategy: oldCommandValue.iteratorStrategy,
          paginateOptions: param.paginateOptions,
          transducers: oldCommandValue.transducers,
          actions: Belt_Array.map(Belt_Array.zip(oldCommandValue.actions, ArrayUtils$SmartcutsMacros.fillTo(Belt_Array.map(actions, (function (action) {
                              return action;
                            })), oldCommandValue.actions.length - actions.length | 0, undefined)), (function (param) {
                  var actionParamValue = param[1];
                  var action = param[0];
                  if (actionParamValue === undefined) {
                    return action;
                  }
                  var exportTo = action._0;
                  return /* ExportTo */{
                          _0: {
                            destination: actionParamValue._0,
                            columns: exportTo.columns,
                            maybeExtraColumns: exportTo.maybeExtraColumns,
                            maybePrimayKeys: exportTo.maybePrimayKeys,
                            snapshotOfDataExported: exportTo.snapshotOfDataExported
                          }
                        };
                }))
        };
}

function updateDestination_encode(v) {
  return [
          "GoogleSheetResolved",
          googleSheet_encode(v._0)
        ];
}

function updateDestination_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "GoogleSheetResolved") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = googleSheet_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* GoogleSheetResolved */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function updateAction_encode(v) {
  return [
          "ExportTo",
          updateDestination_encode(v._0)
        ];
}

function updateAction_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "ExportTo") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = updateDestination_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* ExportTo */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function t_encode$8(v) {
  return Js_dict.fromArray([[
                "actions",
                CustomMap$SmartcutsMacros.MapIntWithDeccoSupport.t_encode(updateAction_encode, v.actions)
              ]]);
}

function t_decode$8(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var actions = CustomMap$SmartcutsMacros.MapIntWithDeccoSupport.t_decode(updateAction_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "actions"), null));
  if (actions.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              actions: actions._0
            }
          };
  }
  var e = actions._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".actions" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function apply(paramValue, update) {
  return {
          actions: Belt_Array.reduce(Belt_MapInt.toArray(update.actions), paramValue.actions, (function (actions, param) {
                  var index = param[0];
                  var match = Belt_Array.get(actions, index);
                  if (match === undefined) {
                    return actions;
                  }
                  var match$1 = match._0;
                  if (match$1.TAG === /* ExistingGoogleSheet */0 || match$1._0.TAG === /* Resolved */0) {
                    return actions;
                  } else {
                    return ArrayUtils$SmartcutsMacros.replaceAtIndex(actions, index, /* ExportTo */{
                                _0: {
                                  TAG: /* NewGoogleSheet */1,
                                  _0: {
                                    TAG: /* Resolved */0,
                                    _0: param[1]._0._0
                                  }
                                }
                              });
                  }
                })),
          paginateOptions: paramValue.paginateOptions
        };
}

var Update = {
  t_encode: t_encode$8,
  t_decode: t_decode$8,
  updateAction_encode: updateAction_encode,
  updateAction_decode: updateAction_decode,
  updateDestination_encode: updateDestination_encode,
  updateDestination_decode: updateDestination_decode,
  apply: apply
};

var PlaybackParamValue = {
  t_encode: t_encode$7,
  t_decode: t_decode$7,
  action_encode: action_encode$4,
  action_decode: action_decode$4,
  destination_encode: destination_encode$2,
  destination_decode: destination_decode$2,
  stringify: stringify$3,
  fromParamDescriptor: fromParamDescriptor,
  toPlaybackCommandValue: toPlaybackCommandValue,
  Update: Update
};

var unknownSpreadsheet = "Unknown";

exports.unknownSpreadsheet = unknownSpreadsheet;
exports.dataNodeId_encode = dataNodeId_encode;
exports.dataNodeId_decode = dataNodeId_decode;
exports.htmlTagPathIdentifier_encode = htmlTagPathIdentifier_encode;
exports.htmlTagPathIdentifier_decode = htmlTagPathIdentifier_decode;
exports.googleSheet_encode = googleSheet_encode;
exports.googleSheet_decode = googleSheet_decode;
exports.snapshotOfDataExported_encode = snapshotOfDataExported_encode;
exports.snapshotOfDataExported_decode = snapshotOfDataExported_decode;
exports.HtpiByTagPathString = HtpiByTagPathString;
exports.DataRecordPattern = DataRecordPattern;
exports.Transducer = Transducer;
exports.CommandValue = CommandValue;
exports.AuthoringConfig = AuthoringConfig;
exports.ParamDescriptor = ParamDescriptor;
exports.PlaybackParamValue = PlaybackParamValue;
/* HtpiByTagPathString Not a pure module */
